import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const liteModeGradient =
  'linear-gradient(135deg, rgb(255, 102, 0), rgb(255, 159, 26))';

const darkModeBackground = 'hsl(220, 15%, 12%)';

export const useStyles = makeStyles<Theme>()((theme) => ({
  thumbIcon: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.3s ease',
    '& > svg': {
      width: '14px',
      height: '14px',
    },
  },
  darkIcon: {
    color: theme.palette.common.white,
    background: darkModeBackground,
  },
  lightIcon: {
    color: theme.palette.primary.main,
    background: theme.palette.common.white,
  },
}));
